import { placements as r } from "./index666.js";
import { popperArrowProps as p } from "./index667.js";
import { useAriaProps as a } from "./index650.js";
import { buildProps as o, definePropType as e } from "./index601.js";
const n = ["fixed", "absolute"], l = o({
  boundariesPadding: {
    type: Number,
    default: 0
  },
  fallbackPlacements: {
    type: e(Array),
    default: void 0
  },
  gpuAcceleration: {
    type: Boolean,
    default: !0
  },
  /**
   * @description offset of the Tooltip
   */
  offset: {
    type: Number,
    default: 12
  },
  /**
   * @description position of Tooltip
   */
  placement: {
    type: String,
    values: r,
    default: "bottom"
  },
  /**
   * @description [popper.js](https://popper.js.org/docs/v2/) parameters
   */
  popperOptions: {
    type: e(Object),
    default: () => ({})
  },
  strategy: {
    type: String,
    values: n,
    default: "absolute"
  }
}), c = o({
  ...l,
  ...p,
  id: String,
  style: {
    type: e([String, Array, Object])
  },
  className: {
    type: e([String, Array, Object])
  },
  effect: {
    type: e(String),
    default: "dark"
  },
  visible: Boolean,
  enterable: {
    type: Boolean,
    default: !0
  },
  pure: Boolean,
  focusOnShow: Boolean,
  trapping: Boolean,
  popperClass: {
    type: e([String, Array, Object])
  },
  popperStyle: {
    type: e([String, Array, Object])
  },
  referenceEl: {
    type: e(Object)
  },
  triggerTargetEl: {
    type: e(Object)
  },
  stopPopperMouseEvent: {
    type: Boolean,
    default: !0
  },
  virtualTriggering: Boolean,
  zIndex: Number,
  ...a(["ariaLabel"]),
  loop: Boolean
}), y = {
  mouseenter: (t) => t instanceof MouseEvent,
  mouseleave: (t) => t instanceof MouseEvent,
  focus: () => !0,
  blur: () => !0,
  close: () => !0
};
export {
  y as popperContentEmits,
  c as popperContentProps,
  l as popperCoreConfigProps
};
